<template>
  <div class="">
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        <!-- Lecturas -->
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field> -->
      </v-card-title>
      <!-- {{ getLoadTable }} -->
      <v-data-table
        :headers="getHeader"
        :items="itemsData"
        :loading="getLoadTable"
        :footer-props="{
          'items-per-page-options': [10],
        }"
        :sort-by="['createdAt']"
        :sort-desc="[true]"
        :items-per-page="10"
        :server-items-length="totalNumberOfItems"
        :options.sync="pagination"
        loading-text="Cargando información …."
      >
        <template v-slot:[`header.name`]="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:[`item.scheduledStatus`]="{ item }">
          <span>Se ejecutara: </span>
          <span class="num_ind _on" v-if="item.scheduledStatus == 'On'">
            Prender
          </span>
          <span class="num_ind _off" v-else>Apagar</span>
        </template>
        <template v-slot:[`item.user`]="{ item }">
          {{ item.user.email }}
        </template>
        <template v-slot:[`item.scheduledDate`]="{ item }">
          {{ item.scheduledDate | formatDate }}
        </template>
        <template v-slot:[`item.createDate`]="{ item }">
          {{ item.createDate | formatDate }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'TableScheduleComp',
  props: {
    list: {
      type: Array,
    },
  },
  components: {},
  data() {
    return {
      search: '',
      flagTable: true,
      EditFlag: false,
      TakeFlag: false,
      ConnectFlag: false,
      itemObjct: {},
      itemsData: [],
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      headerMaster: [
        { text: 'Acción', value: 'scheduledStatus' },
        { text: 'nota', value: 'nota' },
        { text: 'user', value: 'user' },
        { text: 'Fecha de creación', value: 'createDate' },
      ],
      headersClient: [
        { text: 'Accion', value: 'scheduledStatus' },
        { text: 'Nota', value: 'nota' },
        { text: 'user', value: 'user' },
        { text: 'Fecha de creación', value: 'createDate' },
      ],
    }
  },
  async mounted() {
    //await this.listCompany();
    this.getJsonData()
    this.$root.$on('reload', async () => {
      await this.getJsonData()
    })
    //await this.listDevice();
  },
  watch: {
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs
        })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['listDevice']),
    actionTableNull() {
      setTimeout(() => {
        return false
      }, 2000)
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token }
          // console.log('enviando', this.search)

          axios
            .get(
              `device/listschedule?page=${this.pagination.page}&device=${this.$route.params.id}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log(this.$route.params.id, res.data)
              this.itemsData = res.data.docs
              this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data)
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status)
            })
        })
      } catch (error) {
        throw new Error(error.response.data)
      }
    },
  },
  computed: {
    ...mapGetters(['getListDeviceSucess', 'isMaster']),
    loadBar() {
      if (this.itemsData.length > 0) {
        return false
      } else {
        return true
      }
    },
    getLoadTable() {
      //console.log(this.getListDevice);
      if (this.itemsData.length > 0) {
        return false
      } else {
        return this.actionTableNull()
      }
    },
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster
      }
      return this.headersClient
    },
  },
  filters: {
    formatDateFrom: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .fromNow()
      }
      return '-'
    },
    formatDateShort: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .format('LL')
      }
      return '-'
    },
    formatDate: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .format('LLL')
      }
      return '-'
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/base.scss';
span {
  &.num_ind_next {
    color: $dark-jungle-green;
    &._red {
      color: $alert;
    }
    &._orange {
      color: #f48024;
    }
  }
  &.num_ind {
    padding: 1px 5px;
    border-radius: 4px;
    background-color: $dark-jungle-green;
    color: $light-cyan;
    font-size: 0.9rem;
  }
}
.ctn_lasdata {
  p {
    margin: 0;
    &.ctn_lasdata_date {
      font-weight: 600;
      font-size: 0.8rem;
      margin-bottom: 0;
    }
    &.ctn_lasdata_item {
      span {
        border-radius: 4px;
        padding: 1px 5px;
        background-color: $dark-jungle-green;
        color: $light-cyan;
        &.none {
          color: $color-text-grey;
          background-color: transparent;
        }
      }
    }
  }
}
.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}
.span_inactive {
  color: $alert;
}
.list_action {
  padding: 0 2px;
  &:last-child {
    button:hover,
    a:hover {
      background-color: $alert;
    }
  }
  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;
    &.cent {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    width: 100%;
    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }
  span {
    font-size: 0.9rem;
  }
}
span.lbs {
  border-radius: 4px;
  font-size: 0.75rem;
  margin: 2px;
  &.sw_active {
    color: #fff;
    padding: 5px 10px;
    background-color: $bag-green;
  }
  &.sw_inactive {
    padding: 5px 10px;
    background-color: $alert;
    color: #fff;
  }
}
i.i-con {
  font-size: 0.8rem !important;
  &.off {
    color: $alert;
  }
  &.on {
    color: $green-btn;
  }
}
</style>
